import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { Button } from 'muicss/react';
import Modal from 'components/Modal';
import DateUtilities from 'records/DateUtilities';
import { inputDateFormatTS, updatePriceDateFormat } from 'constants/globalPrice';

class GlobalPriceModal extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    changeVisibility: PropTypes.func,
    updateGlobalPrice: PropTypes.func,
    headerString: PropTypes.string,
    descriptionString1: PropTypes.string,
    descriptionString2: PropTypes.string,
    descriptionString3: PropTypes.string,
    priceEffectiveDate: PropTypes.string,
    setPricOutdatedWarning: PropTypes.func,
    isPriceOutdatedWarning: PropTypes.bool,  
  };

  constructor() {
    super();
    this.state = {
      show: false,
    };
  }

  closeModal = () => {
    const { changeVisibility, isPriceOutdatedWarning, setPricOutdatedWarning } = this.props;
    changeVisibility(false, false);
    if (isPriceOutdatedWarning) {
      setPricOutdatedWarning('setAfterPriceOutdatedWarningState');
    }
  };

  startPriceUpdate = () => {
    const {
      updateGlobalPrice,
      changeVisibility,
      isPriceOutdatedWarning,
      setPricOutdatedWarning
    } = this.props;
    changeVisibility(true, false);
    if (isPriceOutdatedWarning) {
      setPricOutdatedWarning('setPriceOutdatedWarningState');
    }
    updateGlobalPrice();
  };

  renderBody = (() => {
    const {
      priceEffectiveDate,
      headerString,
      descriptionString1,
      descriptionString2,
      descriptionString3,
    } = this.props;
    const cutOffDate = moment().subtract(6, 'months').startOf('day');
    const priceEffDate = moment.utc(priceEffectiveDate).local();
    const formattedPriceDate = priceEffectiveDate ? DateUtilities.convertTimeFormatLocal(priceEffectiveDate, inputDateFormatTS, updatePriceDateFormat) : '';

    return (
      <div className={ 'common-overlay-content centered-view' }>
        <h2>{headerString}</h2>
        <div className={ 'content-box-wrapper centered' }>
          <p className={ 'modal-text-description' }>
            {descriptionString1} <b>{formattedPriceDate}</b> 
          </p>
          <p className={ 'modal-text-description' }>
            {descriptionString2}
          </p>
          <p className={ 'modal-text-description' }>
            {descriptionString3}
          </p>
          <div className={ 'modal-custom-btn-panel mb-0 centered' }>
            {
              priceEffDate.isAfter(cutOffDate) ? (
                <Button className='mui-btn--secondary' onClick={ () => this.closeModal() }>
                  No, Don&apos;t Update
                </Button>) : null
            }
            <Button className='mui-btn--success' type='button' onClick={ () => this.startPriceUpdate() }>
              <div>
                { priceEffDate.isAfter(cutOffDate) ? 'Yes, Update' : 'Start Updating Prices' }
              </div>
            </Button>
          </div>
        </div>
      </div>
    );
  });

  render() {
    const { isModalOpen } = this.props;
    return (
      <Modal
        open={ isModalOpen }
        contentComponent={ this.renderBody() }
        disableScroll
        width={ 'common-small-overlay-body xs-size' }
      />
    );
  }
}
export default GlobalPriceModal;
